import axios from 'axios';
import { API_URL } from '../router/APIRouter';

export const getListeFormsan = (url) => axios.post(url);

export const listeFetcherData = async (url, data) => {
    return axios.post (API_URL+url, data);
}
